const assets = {
  CAMERA: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Camera-1.png',
  CROSS_ICON: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Cross.svg',
  ERROR_ICON: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/ErrorIcon-1.png',
  FOCUS: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Focus.png',
  KNOW_MORE: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/KnowMore.png',
  PHONE: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Phone.png',
  SIGNAL: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Signal.png',
  VIDEO: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Video.png',
  WEBSITE: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Website.png',
  FOLLOW_US: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/FollowUs.png',
  CONTACT_US: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/ContactUs.png',
} as const;
export const { 
  CAMERA,
  CROSS_ICON,
  ERROR_ICON,
  FOCUS,
  KNOW_MORE,
  PHONE,
  SIGNAL,
  VIDEO, 
  WEBSITE,
  FOLLOW_US,
  CONTACT_US,
 } = assets;
export default assets;
